import { render } from "./JobseekerSettingsPage.vue?vue&type=template&id=38832416"
import script from "./JobseekerSettingsPage.vue?vue&type=script&lang=js"
export * from "./JobseekerSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__